import React from "react";

const Frontend = () => {
  return (
    <div className="konten__keahlian">
      <h3 className="judul__keahlian">Keahlian</h3>
      <div className="kotak__keahlian">
        <div className="kelompok__keahlian">
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">HTML</h3>
              <span className="tingkat__keahlian">Ahli</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Desain Jersey</h3>
              <span className="tingkat__keahlian">Ahli</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Desain Poster</h3>
              <span className="tingkat__keahlian">Ahli</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">CSS</h3>
              <span className="tingkat__keahlian">Ahli</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">JavaScript</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Python</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Data Science</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>

          <div className="data__keahlian">
          <i className="bx bx-badge-check"></i>
          <div>
            <h3 className="nama__keahlian">Data Analisis</h3>
            <span className="tingkat__keahlian">Menengah</span>
          </div>
        </div>

        <div className="data__keahlian">
          <i className="bx bx-badge-check"></i>
          <div>
            <h3 className="nama__keahlian">Data Visualisasi</h3>
            <span className="tingkat__keahlian">Menengah</span>
          </div>
        </div>


        </div>
        <div className="kelompok__keahlian">
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Bootstrap</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Tailwind</h3>
              <span className="tingkat__keahlian">Pemula</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Git</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">React Js</h3>
              <span className="tingkat__keahlian">Pemula</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">PHP / CI4</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Next JS</h3>
              <span className="tingkat__keahlian">Pemula</span>
            </div>
          </div>


          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Numpy</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>

          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Pandas</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>

          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Matplotlib</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>

          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Seaborn</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Frontend;
